import React, { useState } from 'react';
import { Modal, Table, Button, Form, Input, Space, Popconfirm, Typography, Card, Tag } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { useZonas } from '../../../hooks/useZonas';

const { Text, Title } = Typography;

const ModalGestionZonas = ({ isOpen, setIsOpen }) => {
  const { zonas, isLoading, saveZona, deleteZona } = useZonas();
  const [editingZona, setEditingZona] = useState(null);
  const [form] = Form.useForm();

  const handleOpenCreate = () => {
    setEditingZona(null);
    form.resetFields();
  };

  const handleOpenEdit = (record) => {
    setEditingZona(record);
    form.setFieldsValue({
      nombre: record.nombre,
      descripcion: record.descripcion
    });
  };

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      id: editingZona?.id || null
    };

    saveZona.mutate(payload, {
      onSuccess: () => {
        form.resetFields();
        setEditingZona(null);
      }
    });
  };

  const columns = [
    {
      title: 'Nombre de la Zona / Ruta',
      dataIndex: 'nombre',
      key: 'nombre',
      render: (text) => (
        <Space>
          <EnvironmentOutlined style={{ color: '#166534' }} />
          <Text strong style={{ fontSize: '13px' }}>{text}</Text>
        </Space>
      )
    },
    {
      title: 'Descripción / Cobertura',
      dataIndex: 'descripcion',
      key: 'descripcion',
      render: (text) => text || <Text type="secondary" italic style={{ fontSize: '12px' }}>Sin descripción</Text>
    },
    {
      title: 'Clientes',
      dataIndex: 'total_clientes',
      key: 'total_clientes',
      width: 100,
      align: 'center',
      render: (total) => <Tag color="green">{total || 0} tiendas</Tag>
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: 110,
      align: 'center',
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EditOutlined style={{ color: '#0284c7' }} />}
            onClick={() => handleOpenEdit(record)}
          />
          <Popconfirm
            title="¿Eliminar esta zona?"
            description="Los clientes mantendrán su información pero quedarán 'Sin Zona'."
            onConfirm={() => deleteZona.mutate(record.id)}
            okText="Sí, eliminar"
            cancelText="Cancelar"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={() => {
        setIsOpen(false);
        setEditingZona(null);
        form.resetFields();
      }}
      footer={null}
      width={680}
      centered
      title={
        <Space>
          <EnvironmentOutlined style={{ color: '#22BABB', fontSize: '20px' }} />
          <Title level={4} style={{ margin: 0, fontSize: '18px' }}>Gestión de Zonas y Rutas de Entrega</Title>
        </Space>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '12px' }}>
        
        {/* FORMULARIO DE CREACIÓN / EDICIÓN */}
        <Card size="small" style={{ background: '#f8fafc', borderColor: '#e2e8f0' }}>
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
              <Form.Item
                name="nombre"
                label={<Text strong style={{ fontSize: '12px' }}>{editingZona ? 'Editando Zona' : 'Nueva Zona / Ruta'}</Text>}
                rules={[{ required: true, message: 'Ingresa un nombre' }]}
                style={{ flex: 1, minWidth: '200px', marginBottom: '8px' }}
              >
                <Input placeholder="Ej: Zona Norte, Ruta Poblado..." />
              </Form.Item>

              <Form.Item
                name="descripcion"
                label={<Text type="secondary" style={{ fontSize: '12px' }}>Descripción (Opcional)</Text>}
                style={{ flex: 1.5, minWidth: '220px', marginBottom: '8px' }}
              >
                <Input placeholder="Ej: Barrios Robledo, Castilla y Aranjuez" />
              </Form.Item>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
              {editingZona && (
                <Button size="small" onClick={handleOpenCreate}>
                  Cancelar Edición
                </Button>
              )}
              <Button
                type="primary"
                htmlType="submit"
                size="small"
                loading={saveZona.isPending}
                icon={editingZona ? <EditOutlined /> : <PlusOutlined />}
                style={{ backgroundColor: '#22BABB', borderColor: '#22BABB', fontWeight: '600' }}
              >
                {editingZona ? 'Actualizar Zona' : 'Agregar Zona'}
              </Button>
            </div>
          </Form>
        </Card>

        {/* TABLA DE ZONAS EXISTENTES */}
        <Table
          dataSource={zonas}
          columns={columns}
          rowKey="id"
          loading={isLoading}
          pagination={{ pageSize: 5 }}
          size="small"
        />
      </div>
    </Modal>
  );
};

export default ModalGestionZonas;